<template>
  <div
    class="normalchart"
    style="overflow-y: auto; height: calc(100vh - 260px)"
  >
    <div
      style="
        overflow-y: auto;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      "
      v-if="this.showwhichchart === '1'"
      class="normalchart1"
    >
      <dobar-chart
        :xAxisList="datelist"
        :legend="naturallegend"
        :seriesList="naturalseriesList"
        :yAxisprop="naturalyAxis"
        chartTitle="推广-自然量趋势"
        style="height: 350px; margin-top: 20px; width: 50%"
        ref="dobarchart1"
        :rotateprop="datelist.length > 10 ? 40 : 0"
        :axisLabelinterval="datelist.length > 30 ? 2 : 0"
      ></dobar-chart>

      <dobar-chart
        :xAxisList="datelist"
        :legend="arpulegend"
        :seriesList="arpuseriesList"
        :yAxisprop="arpuyAxis"
        chartTitle="新增-arpu趋势"
        style="height: 350px; margin-top: 20px; width: 50%"
        ref="dobarchart2"
        :rotateprop="datelist.length > 10 ? 40 : 0"
        :axisLabelinterval="datelist.length > 30 ? 2 : 0"
        unit="$"
      ></dobar-chart>

      <dobar-chart
        :xAxisList="datelist"
        :legend="roilegend"
        :seriesList="roiseriesList"
        :yAxisprop="roiyAxis"
        chartTitle="推广成本-ROI趋势"
        style="height: 350px; margin-top: 20px; width: 50%"
        ref="dobarchart3"
        :rotateprop="datelist.length > 10 ? 40 : 0"
        :axisLabelinterval="datelist.length > 30 ? 2 : 0"
        rightunit="$"
      ></dobar-chart>
      <dobar-chart
        :xAxisList="datelist"
        :legend="retenlegend"
        :seriesList="retenseriesList"
        :yAxisprop="retenyAxis"
        chartTitle="留存变化"
        style="height: 350px; margin-top: 20px; width: 50%"
        ref="dobarchart4"
        :rotateprop="datelist.length > 10 ? 40 : 0"
        :axisLabelinterval="datelist.length > 30 ? 2 : 0"
      ></dobar-chart>
      <dobar-chart
        :xAxisList="datelist"
        :legend="recoverylegend"
        :seriesList="recoveryseriesList"
        :yAxisprop="recoveryyAxis"
        chartTitle="当前变现回收趋势"
        style="height: 350px; margin-top: 20px; width: 50%"
        ref="dobarchart7"
        :rotateprop="datelist.length > 10 ? 40 : 0"
        :axisLabelinterval="datelist.length > 30 ? 2 : 0"
      ></dobar-chart>
      <dobar-chart
        :xAxisList="datelist"
        :legend="toDayROIlegend"
        :seriesList="toDayROIseriesList"
        :yAxisprop="toDayROIyAxis"
        chartTitle="活跃增比-当前ROI"
        style="height: 350px; margin-top: 20px; width: 50%"
        ref="dobarchart8"
        :rotateprop="datelist.length > 10 ? 40 : 0"
        :axisLabelinterval="datelist.length > 30 ? 2 : 0"
      ></dobar-chart>
      <dobar-chart
        :xAxisList="datelist"
        :legend="currAlllegend"
        :seriesList="currAllseriesList"
        :yAxisprop="currAllyAxis"
        chartTitle="当前总回收趋势"
        style="height: 350px; margin-top: 20px; width: 50%"
        ref="dobarchart7"
        :rotateprop="datelist.length > 10 ? 40 : 0"
        :axisLabelinterval="datelist.length > 30 ? 2 : 0"
      ></dobar-chart>
      <dobar-chart
        :xAxisList="datelist"
        :legend="inPurchlegend"
        :seriesList="inPurchSeriesList"
        :yAxisprop="inPurchyAxis"
        chartTitle="内购趋势"
        style="height: 350px; margin-top: 20px; width: 50%"
        ref="dobarchart7"
        :rotateprop="datelist.length > 10 ? 40 : 0"
        :axisLabelinterval="datelist.length > 30 ? 2 : 0"
      ></dobar-chart>
    </div>

    <div
      style="
        overflow-y: auto;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      "
      v-else-if="this.showwhichchart == '2'"
    >
      <dobar-chart
        :xAxisList="countryxAxis"
        :legend="countrylegend"
        :seriesList="countryseriesList"
        :yAxisprop="countryyAxis"
        chartTitle="地区回收情况"
        style="height: 550px; margin-top: 20px"
        ref="dobarchart5"
        :rotateprop="40"
      ></dobar-chart>
    </div>

    <div
      style="
        overflow-y: auto;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      "
      v-else-if="this.showwhichchart == '3' || this.showwhichchart == '4'"
    >
      <dobar-chart
        :xAxisList="chnlxAxis"
        :legend="chnllegend"
        :seriesList="chnlseriesList"
        :yAxisprop="chnlyAxis"
        chartTitle="渠道回收情况"
        style="height: 550px; margin-top: 20px"
        ref="dobarchart6"
        :rotateprop="40"
      ></dobar-chart>
    </div>
  </div>
</template>
<script>
import DobarChart from "@/components/DoBarChart";
export default {
  components: {
    DobarChart,
  },
  methods: {
    reflashchart() {
      this.$nextTick(() => {
        // console.log(this.$refs);
        // this.$refs.dobarchart1 && this.$refs.dobarchart1.loading();
        // this.$refs.dobarchart2 && this.$refs.dobarchart2.loading();
        // this.$refs.dobarchart3 && this.$refs.dobarchart3.loading();
        // this.$refs.dobarchart4 && this.$refs.dobarchart4.loading();
        // this.$refs.dobarchart5 && this.$refs.dobarchart5.loading();
        // this.$refs.dobarchart && this.$refs.dobarchart.reflashChart();
        this.$refs.dobarchart1 && this.$refs.dobarchart1.reflashChart();
        this.$refs.dobarchart2 && this.$refs.dobarchart2.reflashChart();
        this.$refs.dobarchart3 && this.$refs.dobarchart3.reflashChart();
        this.$refs.dobarchart4 && this.$refs.dobarchart4.reflashChart();
        this.$refs.dobarchart5 && this.$refs.dobarchart5.reflashChart();
        this.$refs.dobarchart6 && this.$refs.dobarchart6.reflashChart();
        this.$refs.dobarchart7 && this.$refs.dobarchart7.reflashChart();
        this.$refs.dobarchart8 && this.$refs.dobarchart8.reflashChart();
      });
    },
  },
  data() {
    return {
      naturalyAxis: [
        {
          type: "value",
          axisLabel: {
            formatter: "{value} ",
          },
          splitArea: { show: false }, //保留网格区域
        },
        {
          type: "value",
          axisLabel: {
            formatter: "{value} %",
          },
          splitArea: { show: false }, //保留网格区域
        },
      ],
      arpuyAxis: [
        {
          type: "value",
          axisLabel: {
            formatter: "${value}",
          },
          splitArea: { show: false }, //保留网格区域
        },
        {
          type: "value",
          axisLabel: {
            formatter: "{value}",
          },
          splitArea: { show: false }, //保留网格区域
        },
      ],
      roiyAxis: [
        {
          type: "value",
          axisLabel: {
            formatter: "{value}%",
          },
          max: 300,
          splitArea: { show: false }, //保留网格区域
        },
        {
          type: "value",
          axisLabel: {
            formatter: "${value}",
          },
          splitArea: { show: false }, //保留网格区域
        },
      ],
      retenyAxis: [
        {
          type: "value",
          axisLabel: {
            formatter: "{value}%",
          },
          splitArea: { show: false }, //保留网格区域
        },
        {
          type: "value",
          axisLabel: {
            formatter: "{value}",
          },
          splitArea: { show: false }, //保留网格区域
        },
      ],
      recoveryyAxis: [
        {
          type: "value",
          axisLabel: {
            formatter: "{value}",
          },
          splitArea: { show: false }, //保留网格区域
        },
        {
          type: "value",
          axisLabel: {
            formatter: "{value}%",
          },
          splitArea: { show: false }, //保留网格区域
        },
      ],
      toDayROIyAxis: [
        {
          type: "value",
          axisLabel: {
            formatter: "{value}%",
          },
          splitArea: { show: false }, //保留网格区域
        },
        {
          type: "value",
          axisLabel: {
            formatter: "{value}",
          },
          splitArea: { show: false }, //保留网格区域
        },
      ],
      currAllyAxis: [
        {
          type: "value",
          axisLabel: {
            formatter: "{value}",
          },
          splitArea: { show: false }, //保留网格区域
        },
        {
          type: "value",
          axisLabel: {
            formatter: "{value}%",
          },
          splitArea: { show: false }, //保留网格区域
        },
      ],
      inPurchyAxis: [
        {
          type: "value",
          axisLabel: {
            formatter: "{value}",
          },
          splitArea: { show: false }, //保留网格区域
        },
        {
          type: "value",
          axisLabel: {
            formatter: "{value}%",
          },
          // max: 300,
          splitArea: { show: false }, //保留网格区域
        },
      ],
      country: null,
      countryyAxis: [
        {
          type: "value",
          axisLabel: {
            formatter: "{value}%",
          },
          max: 300,
          splitArea: { show: false }, //保留网格区域
        },
        {
          type: "value",
          axisLabel: {
            formatter: "{value}",
          },
          splitArea: { show: false }, //保留网格区域
        },
      ],
      chnlyAxis: [
        {
          type: "value",
          axisLabel: {
            formatter: "{value}%",
          },
          max: 300,
          splitArea: { show: false }, //保留网格区域
        },
        {
          type: "value",
          axisLabel: {
            formatter: "{value}",
          },
          splitArea: { show: false }, //保留网格区域
        },
      ],
    };
  },
  props: {
    showwhichchart: String,
    datelist: {
      type: Array,
      default: () => [],
    },
    naturallegend: {
      type: Array,
      default: () => [],
    },
    arpulegend: {
      type: Array,
      default: () => [],
    },
    roilegend: {
      type: Array,
      default: () => [],
    },
    retenlegend: {
      type: Array,
      default: () => [],
    },
    naturalseriesList: {
      type: Array,
      default: () => [],
    },
    arpuseriesList: {
      type: Array,
      default: () => [],
    },
    roiseriesList: {
      type: Array,
      default: () => [],
    },
    retenseriesList: {
      type: Array,
      default: () => [],
    },
    countryseriesList: {
      type: Array,
      default: () => [],
    },
    countryxAxis: {
      type: Array,
      default: () => [],
    },
    countrylegend: {
      type: Array,
      default: () => [],
    },
    chnlseriesList: {
      type: Array,
      default: () => [],
    },
    chnllegend: {
      type: Array,
      default: () => [],
    },
    chnlxAxis: {
      type: Array,
      default: () => [],
    },
    recoveryseriesList: {
      type: Array,
      default: () => [],
    },
    recoverylegend: {
      type: Array,
      default: () => [],
    },
    toDayROIseriesList: {
      type: Array,
      default: () => [],
    },
    toDayROIlegend: {
      type: Array,
      default: () => [],
    },
    currAlllegend: {
      type: Array,
      default: () => [],
    },
    currAllseriesList: {
      type: Array,
      default: () => [],
    },
    inPurchlegend: {
      type: Array,
      default: () => [],
    },
    inPurchSeriesList: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    "$store.state.Summary.country": {
      handler(n, o) {
        if (n !== o) {
          this.country = n;
        }
      },
      deep: true, //对象内部属性的监听，关键。
    },
  },
};
</script>